// Ignore errors that don't originate from our own bundle.
// All app code is served from /_nuxt/, so errors whose stack trace has no frame
// from there come from scripts injected into the page (in-app browsers,
// translators, extensions) and are not actionable.

export default defineNuxtPlugin(() => {
  useBugsnag().addOnError((event) => {
    const frames = event.errors?.[0]?.stacktrace || [];

    if (!frames.length) return true;

    return frames.some(frame => frame.file?.includes('/_nuxt/'));
  });
});
